import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 lg:grid-cols-12 lg:gap-8 lg:py-20">
        {/* copy column */}
        <div className="lg:col-span-6 xl:col-span-6">
          <div className="inline-flex items-center gap-2 rounded-full bg-primary-100/80 px-3 py-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
            <span className="font-label text-xs font-medium tracking-wide text-primary-700">深挖背后真相 · 持续更新</span>
          </div>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-snug tracking-tight text-foreground-950 md:text-5xl md:leading-snug">
            传闻只停在表面，
            <br />
            我们往下再挖三层。
          </h1>

          <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-foreground-700 md:text-lg">
            免费黑料专注深度内幕挖掘，把<strong className="font-semibold text-foreground-900">未公开细节</strong>与{" "}
            <strong className="font-semibold text-foreground-900">内幕消息</strong>做独家爆料。不追热搜的 10 秒热度，
            只还你事件背后那份被隐去的完整拼图。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#resource"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              进入深挖入口
              <i className="ri-arrow-right-line ml-2 text-base" />
            </a>
            <a
              href="#archive"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 font-label text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-folder-2-line mr-2 text-base" />
              翻看独家档案
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-2 font-label text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5"><i className="ri-checkbox-circle-line text-accent-600 text-sm" />只讲可查证</span>
            <span className="inline-flex items-center gap-1.5"><i className="ri-checkbox-circle-line text-accent-600 text-sm" />每周深挖专题</span>
            <span className="inline-flex items-center gap-1.5"><i className="ri-checkbox-circle-line text-accent-600 text-sm" />基于公开来源整理</span>
          </div>
        </div>

        {/* figure column */}
        <div className="lg:col-span-6 xl:col-span-6">
          <div className="relative mx-auto max-w-xl lg:ml-auto lg:mr-0">
            <div className="absolute -inset-3 rounded-2xl bg-gradient-to-tr from-primary-100/60 via-background-100 to-accent-100/70" />
            <div className="relative overflow-hidden rounded-xl border border-background-200">
              <div className="h-72 w-full md:h-[420px] lg:h-[460px]">
                <img
                  src="https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20of%20old%20newspaper%20clippings%2C%20typed%20documents%20and%20a%20magnifying%20glass%20on%20warm%20cream%20desk%2C%20red%20highlighter%20marks%20and%20pinned%20notes%2C%20investigative%20newsroom%20aesthetic%2C%20soft%20window%20light%2C%20magazine%20layout%2C%20no%20people%2C%20high%20detail&width=900&height=1000&seq=hero-main&orientation=portrait"
                  alt="深挖档案工作台：报纸剪报、文档与放大镜铺陈在暖色桌面上"
                  title="免费黑料 深挖档案"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/20 to-transparent" />
              <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between rounded-lg bg-background-50/90 px-4 py-3 backdrop-blur">
                <div>
                  <p className="font-label text-xs text-foreground-500">今日独家档案</p>
                  <p className="mt-0.5 font-heading text-sm font-bold text-foreground-900">一档综艺停播背后的三个月</p>
                </div>
                <a
                  href="#feature"
                  className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50"
                  aria-label="查看专题"
                >
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>

            <div className="absolute -left-3 top-6 hidden rounded-xl border border-background-200 bg-background-50 px-4 py-3 shadow-sm md:block">
              <p className="font-label text-[11px] text-foreground-500">归档内幕文件</p>
              <p className="mt-0.5 font-heading text-xl font-bold text-primary-600">300+</p>
            </div>
          </div>

          <div className="mx-auto mt-6 grid w-full max-w-xl grid-cols-3 gap-3 lg:mx-0 lg:max-w-none">
            {heroStats.map((s) => (
              <div key={s.label} className="rounded-lg border border-background-200 bg-background-50 px-4 py-3">
                <p className="font-heading text-2xl font-bold text-foreground-950">{s.value}</p>
                <p className="mt-0.5 font-label text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}